module.exports = require("./InAppMessaging")
